var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIconGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.4.6.111.827-.261.827-.58 0-.285-.01-1.045-.015-2.047-3.338.728-4.042-1.61-4.042-1.61-.546-1.387-1.333-1.757-1.333-1.757-1.086-.743.083-.728.083-.728 1.201.084 1.832 1.237 1.832 1.237 1.064 1.822 2.802 1.293 3.48.992.106-.771.416-1.292.756-1.592-2.665-.31-5.465-1.331-5.465-5.923 0-1.305.469-2.376 1.237-3.216-.123-.31-.536-1.558.117-3.247 0 0 1.007-.32 3.303 1.228.96-.267 1.986-.399 3.003-.403 1.017.004 2.043.136 3.003.403 2.296-1.548 3.303-1.228 3.303-1.228.653 1.689.24 2.937.117 3.247.768.84 1.237 1.911 1.237 3.216 0 4.607-2.8 5.606-5.465 5.923.34.3.65.891.65 1.779 0 1.288-.01 2.458-.01 2.751 0 .319.228.692.83.58C20.563 21.8 24 17.302 24 12c0-6.627-5.373-12-12-12z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconGithub);
export default __webpack_public_path__ + "static/media/nav-icon-github.602ab3e66e11bf66c75d7fa781bec0a5.svg";
export { ForwardRef as ReactComponent };